module.exports = __webpack_public_path__ + "img/section3_2.1989628f.png";